import * as React from "react";
const SvgFiRrCircleThreeQuarters = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-three-quarters_svg__a)">
      <path
        fill="#062147"
        d="M11.98 24c-.44 0-.89-.02-1.34-.07C5.13 23.32.68 18.87.08 13.36-.61 7.2 3.5 1.36 9.43.07c.86-.19 1.75.03 2.44.58.72.58 1.13 1.44 1.13 2.36V11h7.99c.92 0 1.78.41 2.36 1.13.56.69.77 1.58.58 2.44-1.2 5.49-6.31 9.43-11.96 9.43zM10.04 2c-.06 0-.12 0-.19.02C4.92 3.1 1.49 7.98 2.06 13.14c.51 4.59 4.21 8.29 8.79 8.79 5.17.58 10.05-2.85 11.12-7.79a.88.88 0 0 0-.19-.76c-.2-.25-.49-.39-.8-.39H12c-.55 0-1-.45-1-1V3.01c0-.31-.14-.61-.39-.8a.95.95 0 0 0-.57-.21"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-three-quarters_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleThreeQuarters;
